var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M18.6897 11.5308C18.1197 11.3808 17.4497 11.3008 16.6497 11.3008C15.5397 11.3008 15.1297 11.5708 14.5597 12.0008C14.5297 12.0208 14.4997 12.0508 14.4697 12.0808L13.5197 13.0908C12.7197 13.9308 11.2797 13.9408 10.4797 13.0808L9.52969 12.0808C9.49969 12.0508 9.46969 12.0208 9.43969 12.0008C8.86969 11.5708 8.45969 11.3008 7.34969 11.3008C6.54969 11.3008 5.87969 11.3808 5.30969 11.5308C2.92969 12.1708 2.92969 14.0608 2.92969 15.7208V16.6508C2.92969 19.1608 2.92969 22.0008 8.27969 22.0008H15.7197C19.2697 22.0008 21.0697 20.2008 21.0697 16.6508V15.7208C21.0697 14.0608 21.0697 12.1708 18.6897 11.5308ZM14.3297 18.4008H9.66969C9.28969 18.4008 8.97969 18.0908 8.97969 17.7008C8.97969 17.3108 9.28969 17.0008 9.66969 17.0008H14.3297C14.7097 17.0008 15.0197 17.3108 15.0197 17.7008C15.0197 18.0908 14.7097 18.4008 14.3297 18.4008Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M19.2091 6.42V10.12C19.1691 10.1 19.1191 10.09 19.0791 10.08C18.3791 9.89 17.5891 9.8 16.6491 9.8C15.1091 9.8 14.3891 10.25 13.6491 10.81C13.5491 10.88 13.4591 10.97 13.3791 11.05L12.4191 12.06C12.3291 12.16 12.1691 12.22 11.9991 12.22C11.8291 12.22 11.6691 12.16 11.5691 12.05L10.6291 11.06C10.5391 10.96 10.4391 10.87 10.3391 10.8C9.61906 10.25 8.88906 9.8 7.34906 9.8C6.40906 9.8 5.61906 9.89 4.91906 10.08C4.87906 10.09 4.82906 10.1 4.78906 10.12V6.42C4.78906 4.35 4.78906 2 9.20906 2H14.7891C19.2091 2 19.2091 4.35 19.2091 6.42Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }